import { render } from "./firstTimersReport.vue?vue&type=template&id=774c40b4&scoped=true"
import script from "./firstTimersReport.vue?vue&type=script&lang=js"
export * from "./firstTimersReport.vue?vue&type=script&lang=js"

import "./firstTimersReport.vue?vue&type=style&index=0&id=774c40b4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774c40b4"]])

export default __exports__